import {createFeatureSelector, createSelector} from "@ngrx/store";
import {FundAiSetupState} from "./fund-ai-setup.state";
import {AiSetupJobInfo} from "../../fund/generated-sources/api";

export const FUND_AI_SETUP_FEATURE_KEY = "fundAiSetup";

export const selectFundAiSetupState = createFeatureSelector<FundAiSetupState>(FUND_AI_SETUP_FEATURE_KEY);

export const selectJobsForFund = (fundId: number) => createSelector(
    selectFundAiSetupState,
    state => state.jobsByFund[fundId]?.data ?? []
);

const ACTIVE_STATUSES = new Set<string>(["NEW", "IN_PROGRESS"]);

export const selectActiveJobForFund = (fundId: number) => createSelector(
    selectJobsForFund(fundId),
    (jobs: AiSetupJobInfo[]) => jobs.find(j => ACTIVE_STATUSES.has(j.status as unknown as string))
);

export const selectMostRecentReadyJobForFund = (fundId: number) => createSelector(
    selectJobsForFund(fundId),
    (jobs: AiSetupJobInfo[]) =>
        jobs.find(j => j.status as unknown as string === "COMPLETED" && (j.pendingReviewCount ?? 0) > 0)
);

export const selectHasActiveJobsForFund = (fundId: number) => createSelector(
    selectActiveJobForFund(fundId),
    job => job !== undefined
);

export const selectActiveDetail = createSelector(
    selectFundAiSetupState,
    state => state.activeDetail.data
);

export const selectActiveDetailStatus = createSelector(
    selectFundAiSetupState,
    state => state.activeDetail.status
);

export const selectIsResultPending = (resultId: number) => createSelector(
    selectFundAiSetupState,
    state => state.pendingActionResultIds.includes(resultId)
);

export const selectGlobalError = createSelector(
    selectFundAiSetupState,
    state => state.error
);
